module.exports = __webpack_public_path__ + "img/not-found-mobile.7b6fab4.a4368b4.svg";